import _ from 'lodash';
import React, { Component } from 'react';

import {
  getIcon,
  dealAmountAsString,
} from '../../util';

import ReactTooltip from 'react-tooltip';

class CurrencyTip extends Component {

  render(){

    const { deal } = this.props;

    if(!deal || !deal.currency){
      return null;
    }

    return (
      <div className="currency-tip">
        <div data-tip={'USD ' + dealAmountAsString(deal, true)} className="currency-tip-icon">{getIcon('dollar')}</div>
        <ReactTooltip effect="solid" place="top" />
      </div>
    )
  }
}
export default CurrencyTip;



// WEBPACK FOOTER //
// ./src/components/shared/currencyTip.js